export default {
  derivas: {
    grau_polinomio : 'O campo é obrigatório (valor deve ser > {min} e <= {max})'
  }
};
